import { graphql } from '@apollo/client/react/hoc'

import { localISODate } from '../../helpers/date-helpers'
import getImageFromEntry, {
  MASTER,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import { getLogoFromRetailer } from '../../helpers/get-logo-from-retailer'
import { getPaymentMethodsFromRetailer } from '../../helpers/get-payment-methods-from-retailer'
import { getCTAFromRetailer } from '../../helpers/get-cta-from-retailer'
import getDescriptiveLocation from '../../helpers/get-descriptive-location'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { storeAcceptsGiftCard } from '../../helpers/store-helper'
import { GIFT_CARD_TEXT } from '../../constants'
import getWhatsHappeningItem from '../../helpers/get-whats-happening-item'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ match, centre }) => ({
  context: { version: 1 },
  variables: {
    id: match.params.id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({
  ownProps: {
    centre,
    match: { params },
  },
  data,
}) => {
  const { loading, error, store } = data
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!store || store.centre.sys.id !== centre.sys.id) {
    return {
      error: new NotFoundError(error),
    }
  } else if (store.centre.cinema && params.id === store.centre.cinema.sys.id) {
    return { redirect: `/${params.centre}/movies` }
  } else if (params.slug !== store.slug) {
    return { redirect: `/${params.centre}/store/${params.id}/${store.slug}` }
  }
  const { events, news, offers, stories } = store
  const allItems = [...events, ...news, ...offers, ...stories]

  const items = allItems
    .sort((a, b) => new Date(b.sys.updatedAt) - new Date(a.sys.updatedAt))
    .reduce((tempItems, item) => {
      const whatsHappeningItem = getWhatsHappeningItem(item, centre)
      const location = getDescriptiveLocation({
        level: item.level,
        physicalAddress: item.physicalAddress,
        hosted: item.hosted,
        ...(store && { storeTitle: store.title }),
      })

      tempItems.push({
        ...whatsHappeningItem,
        location,
      })
      return tempItems
    }, [])
  const paymentMethods = getPaymentMethodsFromRetailer(store)
  const offerings = [
    ...(storeAcceptsGiftCard(paymentMethods) ? [GIFT_CARD_TEXT] : []),
  ]
  return {
    store: {
      ...store,
      callsToAction: getCTAFromRetailer(store),
      storeFrontImage: store.storeFrontImage ? store.storeFrontImage.url : null,
      summary: store.longDescription || store.retailer.longDescription,
      desktopImage: getImageFromEntry(store, MASTER),
      mobileImage: getImageFromEntry(store, STANDARD),
      logo: getLogoFromRetailer(store.retailer),
      phone: store.telephoneNumber,
      url: store.websiteAddress,
      location: store.physicalAddress,
      experiences: store.experiences,
      retailCategories: store.retailCategories,
      topics: store.topics,
      nearestLocation: store.landmarkDescription,
      parkingLocation: store.parkingInstructions,
      openHours: {
        storeTradingSchedule: store.storeTradingSchedule,
        centreTradingSchedule: centre.centreTradingSchedule,
        timeZone: centre.timeZone,
      },
      services: store.services || [],
      storeImage: '',
      offerings,
      paymentMethods,
      happeningsInStore: items,
      analyticsMetadata: store.analyticsMetadata,
    },
  }
}

const withStore = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withStore
